// Mock posthog-js stub — posthog-js is not installed in this environment
const posthog = {
  init: () => {},
  capture: () => {},
  identify: () => {},
  reset: () => {},
  opt_out_capturing: () => {},
  opt_in_capturing: () => {},
  has_opted_out_capturing: () => false,
};

export default posthog;
